import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewOrgDialog = ({ open, close, advertiser }) => {
  const { userData } = React.useContext(EventContext);
  const [data, setData] = React.useState({});
  const [orgs, setOrgs] = React.useState([]);
  const [selectedOrg, setSelectedOrg] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    setData(advertiser);
  }, [advertiser]);

  React.useEffect(() => {
    if (userData && userData?.role === "superadmin") {
      getOrgs();
    }
  }, [userData]);

  React.useEffect(() => {
    if (orgs.length > 0 && data) {
      const org = orgs.filter((o) => o._id === data.org);
      setSelectedOrg(org[0]);
    }
  }, [orgs, data]);

  const getOrgs = async () => {
    const result = await request("orgs");
    if (result.success) {
      if (result.orgs) {
        setOrgs(result.orgs);
      }
    }
  };

  const handleOrgChange = (orgName) => {
    const org = orgs.filter((o) => o.name === orgName);
    setSelectedOrg(org[0]);
    setData({ ...data, org: org[0]._id });
  };

  const handleSave = async () => {
    setError(null);
    let error;
    let result;
    let body;

    if (advertiser) {
      let update = {};
      if (data.name !== advertiser.name) {
        update.name = data.name;
      }
      if (data.org !== advertiser.org) {
        update.org = data.org;
      }
      if (data.active !== advertiser.active) {
        update.active = data.active;
      }

      body = {
        advertiserId: advertiser._id,
        update,
      };

      result = await request("ads/advertiser/update", "post", body);
      if (!result.success) {
        alert(result.error);
        return;
      }
      setSelectedOrg(null);
      setData({});
      close();
      return;
    }

    if (!data?.name) {
      alert("Please enter an Advertiser name");
      return;
    } else if (userData.role === "superadmin" && !data?.org) {
      alert("Please select and organization");
      return;
    }

    //create new advertiser
    body = { name: data.name, active: true };
    if (selectedOrg) {
      body.orgId = selectedOrg._id
    }
    result = await request("ads/advertiser/create", "post", body);
    if (!result.success) {
      alert(result.error);
    }

    setSelectedOrg(null);
    setData({});
    close();
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {advertiser ? "Edit Advertiser" : "New Advertiser"}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}
          <Grid item>
            <TextField
              fullWidth
              label="Advertiser Name"
              value={data?.name ? data?.name : ""}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>
          {userData?.role === "superadmin" && (
            <Grid item>
              <FormControl fullWidth>
                <InputLabel>Org</InputLabel>
                <Select
                  value={selectedOrg ? selectedOrg.name : ""}
                  label="Lower Range Value"
                  autoWidth
                  onChange={(e) => handleOrgChange(e.target.value)}
                >
                  {orgs.map((org) => {
                    return (
                      <MenuItem key={org._id} value={org.name}>
                        {org.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox checked={data?.active ? data.active : false} />
              }
              onChange={() => setData({ ...data, active: !data.active })}
              label="Active"
            />
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default NewOrgDialog;
